import { useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import { GET_PAGE_DESCRIPTION_DATA } from '@/graphql/media-buying-queries'
import { showNotification } from '@/utils/notifications'
import iconPlaceholder from '@/assets/images/media-buying/icon-placeholder.png'

export const usePageData = (connectedPublishers) => {
    const [pageTitle, setPageTitle] = useState('Page Name')
    const [pageIcon, setPageIcon] = useState(iconPlaceholder)
    const [pageLink, setPageLink] = useState('')

    const [fetchPageDescriptionData, { data: pageDescriptionData, loading, error }] = useLazyQuery(
        GET_PAGE_DESCRIPTION_DATA,
        {
            fetchPolicy: 'network-only',
            onError: (err) => {
                console.error('Page Data failed:', err)
                err.graphQLErrors.forEach(({ message, extensions }) => {
                    if (extensions.code === 'PUBLISHER_API_ERROR') {
                        showNotification(message, 'error')
                    }
                })
            },
        },
    )

    // Fetch page data when connected publishers change
    useEffect(() => {
        if (connectedPublishers) {
            const thisPublisher = Object.values(connectedPublishers)?.[0]
            if (thisPublisher) {
                fetchPageDescriptionData({
                    variables: {
                        publisherId: thisPublisher.publisher_id,
                        pageId: thisPublisher.page_id,
                        // Scopes the Meta credential to this licence rather than the
                        // user's most recently authorised one.
                        campaignId: thisPublisher.campaign_id,
                    },
                })
            }
        }
    }, [connectedPublishers, fetchPageDescriptionData])

    // Update state when data is received
    useEffect(() => {
        if (pageDescriptionData) {
            const { name, picture, link } = pageDescriptionData.publisherPageData || {}
            setPageIcon(picture?.data?.url || iconPlaceholder)
            setPageTitle(name || 'Page Name')
            setPageLink(link || '')
        }
    }, [pageDescriptionData])

    return {
        pageTitle,
        pageIcon,
        pageLink,
        publisherId: connectedPublishers ? Object.values(connectedPublishers)?.[0]?.publisher_id : '',
        campaignId: connectedPublishers ? Object.values(connectedPublishers)?.[0]?.campaign_id : '',
        pageId: connectedPublishers ? Object.values(connectedPublishers)?.[0]?.page_id : '',
        loading,
        error,
        refetch: fetchPageDescriptionData,
    }
}
